import { API_ENDPOINTS } from '../config/api';
import { BaseApiService, ApiResponse } from './baseApi';

/** Matches invoice-service TransporterMaster entity (field names may vary slightly). */
export interface TransporterMaster {
  id: number;
  transporterId?: string;
  transporterName?: string;
}

export function getTransporterDisplayName(t: TransporterMaster): string {
  const label = t.transporterName ?? t.transporterId;
  return label?.trim() ? label.trim() : `Transporter #${t.id}`;
}

class TransporterMasterApiService extends BaseApiService {
  async create(
    data: {
      transporterId?: string;
      transporterName?: string;
    }
  ): Promise<ApiResponse<TransporterMaster>> {
    return this.makeRequest<ApiResponse<TransporterMaster>>(
      API_ENDPOINTS.INVOICES.TRANSPORTER_MASTERS,
      {
        method: 'POST',
        body: JSON.stringify(data),
      }
    );
  }

  async getAll(): Promise<ApiResponse<TransporterMaster[]>> {
    return this.makeRequest<ApiResponse<TransporterMaster[]>>(
      API_ENDPOINTS.INVOICES.TRANSPORTER_MASTERS,
      { method: 'GET' }
    );
  }

  /** GET /invoice/transporter-masters/search?keyword= */
  async search(keyword: string): Promise<ApiResponse<TransporterMaster[]>> {
    const params = new URLSearchParams({ keyword });
    return this.makeRequest<ApiResponse<TransporterMaster[]>>(
      `${API_ENDPOINTS.INVOICES.TRANSPORTER_MASTERS_SEARCH}?${params.toString()}`,
      { method: 'GET' }
    );
  }
}

export const transporterMasterApiService = new TransporterMasterApiService();
